// src/GuestLogin.jsx
import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from './firebase';

import './RiderLogin.css';

const GuestLogin = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const loginGuest = async () => {
    if (!name.trim() || !email.trim() || !phone.trim()) {
      alert('Please enter your name, email, and phone number');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    try {
      const docRef = await addDoc(collection(db, 'guest'), {
        name,
        email,
        phone,
        createdAt: new Date(),
      });

      const guestUid = docRef.id;
      console.log('New guest document ID:', guestUid);

      localStorage.setItem('userType', 'guest');
      localStorage.setItem('guestName', name.trim());
      localStorage.setItem('guestEmail', email.trim());
      localStorage.setItem('guestPhone', phone.trim());
      localStorage.setItem('guestUid', guestUid);

      alert('Guest login successful!');
      navigate('/map');
    } catch (error) {
      alert(`Error logging in guest: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="rider-login-container">
      <img src="https://u-gotaxi.co.uk/react-widget/assets/logo_ugo_taxi.png" alt="UGO Logo" className="rider-logo" />
      <h2>Guest Login</h2>

      <div className="input-box">
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="input-box">
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input-box">
        <input
          type="tel"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      <button className="login-btn" onClick={loginGuest} disabled={isLoading}>
        {isLoading ? 'Logging in...' : 'Login as Guest'}
      </button>

      <button className="back-btn" onClick={() => navigate('/')}>
        Back to Role Selection
      </button>
    </div>
  );
};

export default GuestLogin;
